import React from "react";
import { Users, User } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface CoverImageProps {
  title: string;
  coverImageUrl?: string | null;
  isActive: boolean;
  isGroup?: boolean;
  maxParticipants?: number;
}

export const CoverImage: React.FC<CoverImageProps> = ({
  title,
  coverImageUrl,
  isActive,
  isGroup = false,
  maxParticipants = 1
}) => {
  const defaultCover = "/placeholder.svg";
  
  return (
    <div className="relative h-48 w-full">
      <div 
        className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#181D24]/90"
      />
      <img
        src={coverImageUrl || defaultCover}
        alt={title}
        className="w-full h-full object-cover"
      />
      
      {/* Title - area da parte inferior */}
      <div className="absolute bottom-3 left-3 right-3">
        <h3 className="text-xl font-bold text-[#00B6F0] truncate px-3 py-2 bg-[#1A2233]/80 backdrop-blur-sm rounded-lg">
          {title}
        </h3>
      </div>

      {/* Session Type Badge */}
      <div className="absolute top-3 left-3">
        <Badge 
          variant={isGroup ? "outline" : "default"}
          className={`px-2 py-1 flex items-center gap-1 ${
            isGroup 
              ? "bg-purple-900/80 text-purple-200 border-purple-700" 
              : "bg-green-900/80 text-green-200 border-green-700"
          }`}
        >
          {isGroup ? <Users className="h-3 w-3" /> : <User className="h-3 w-3" />}
          {isGroup ? `Em Grupo (${maxParticipants})` : "Individual"}
        </Badge>
      </div>
      
      {/* Status Badge */}
      {!isActive && (
        <div className="absolute top-3 right-3">
          <span className="px-2 py-1 text-xs bg-gray-700/80 text-gray-300 rounded">Inativo</span>
        </div>
      )}
    </div>
  );
};
